const TenantAvatar: React.FC<{ name: string; url?: string | null }> = ({ name, url }) => {
    const initials = name
        .split(" ")
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();

    if (url) {
        return (
            <img
                src={url}
                alt={name}
                className="ac-avatar"
                onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = "none";
                }}
            />
        );
    }

    return <div className="ac-avatar ac-avatar-initials">{initials}</div>;
};

export default TenantAvatar;